import { takeEvery, call, put, select } from 'redux-saga/effects';
import { actions, types } from '../modules/staff';
import { C, Utils } from '@kineticdata/bundle-common';
import { fetchUsers } from '@kineticdata/react';

export function* fetchStaffSaga() {
  const profile = yield select(state => state.app.profile);

  if (profile) {
    const { users, error } = yield call(fetchUsers, {
      include: 'profileAttributesMap',
      q: `enabled = "true" AND attributes[${
        C.ATTRIBUTE_USER_COMPANY
      }] = "${Utils.getAttributeValue(profile, C.ATTRIBUTE_USER_COMPANY, '')}"`,
    });

    if (error) {
      yield put(actions.fetchStaffFailure(error));
    } else {
      yield put(actions.fetchStaffSuccess(users));
    }
  } else {
    yield put(actions.fetchStaffFailure({ message: 'Profile not found' }));
  }
}

export function* watchStaff() {
  yield takeEvery(types.FETCH_STAFF_REQUEST, fetchStaffSaga);
}
